import { useFormContext } from "react-hook-form";
import { RegisterUserInput } from "@/types";
import { useEffect } from "react";

type StepType =
  | "lang"
  | "birth_date"
  | "password"
  | "confirm_password"
  | "profession"
  | "email"
  | "referer"
  | "start_month"
  | "sector"
  | "token";

const useFormStep = (step: StepType) => {
  const { setValue, getValues, trigger, getFieldState } =
    useFormContext<RegisterUserInput>();

  useEffect(() => {
    void trigger().then(() => null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defaultValue = getValues(step as never);
  const handleChange = (value: string) => {
    setValue(step, value, {
      shouldValidate: true,
    });
    void trigger().then(() => null);
  };
  const { error, invalid } = getFieldState(step);

  return { handleChange, defaultValue, invalid, error };
};
export default useFormStep;
